<template>
    <QOpenApp v-if="showComp" v-bind="$attrs" v-on="$listeners" :systemInfo="storeCommon.systemInfo" :url="props.url" :channel="props.channel" :wxInfo="wxInfo"  :schema="props.schema" ><slot></slot></QOpenApp> 
</template>

<script lang="ts" setup>
import { ref, PropType, onMounted, computed } from 'vue';
import { useStoreCommon } from '../../store/common';
import { QOpenApp } from '@q-front-npm/h5-ui';
/* 微信sdk打开时，拼接不了channel(客户端内部处理有bug)，需要业务自行处理（如：传递参数+埋点上报）  */
const props = withDefaults(
    defineProps<{
        url: string;
        channel?: string;
        schema?: Record<string, string>;
        api:(url: string) => Promise<any>;
    }>(),
    {
        url: '',
        channel: '',
    }
);
const storeCommon = useStoreCommon();
const wxInfo = ref();
const showComp = ref(false);
const initWxInfo = async() => {
    if (!storeCommon.systemInfo.isWeixin) {
        showComp.value = true;
        return;
    }
    try {
        const res = await props.api(location.href.split('#')[0]);
        wxInfo.value = {
            appId: res.app_id,
            nonceStr: res.nonce_str,
            ...res,
        };
    } finally {
        showComp.value = true;
    }
};
initWxInfo();

</script>
